export default __webpack_public_path__ + "static/media/illustration-contact.e805f849.svg";